import { degraded } from 'helper/zod';
import { z } from 'zod';

import type { SystemVersionFE, SystemVersionItemFE } from '../system';
import { safeOptional } from './restMapping';

const label = (field: string) => `versionFromRestV1.${field}`;

const WireVersionItemObjectSchema = z.object({
    service: safeOptional(z.string(), label('services[].service')),
    version: safeOptional(z.string(), label('services[].version')),
});

const WireVersionObjectSchema = z.object({
    version: z.string().min(1),
    services: safeOptional(z.array(WireVersionItemObjectSchema), label('services')),
});

/** Exported for `mocks/tests/restContract.test.ts`. */
export const WireVersionSchema = WireVersionObjectSchema;

type WireVersionItem = z.infer<typeof WireVersionItemObjectSchema>;

/** Degrade per entry: one unnamed service must not discard the whole list. */
const toServiceItems = (services: WireVersionItem[] | null | undefined): SystemVersionItemFE[] =>
    (services ?? []).reduce<SystemVersionItemFE[]>((acc, entry) => {
        if (!entry.service) {
            console.error(degraded(label('services[].service'), 'entry dropped, no service name'), entry);
            return acc;
        }
        acc.push({ service: entry.service, version: entry.version ?? '' });
        return acc;
    }, []);

export const versionFromRestV1 = (raw: unknown): SystemVersionFE => {
    const wire = WireVersionSchema.parse(raw);
    return {
        version: wire.version,
        services: toServiceItems(wire.services),
    };
};
